export default __webpack_public_path__ + "static/media/upload-img.10e4e4f4.svg";